/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';

import creatBlobFromBase64 from '../../../helpers/utils';

import style from './CommunicationPanelCard.module.css';
import SingleLineData from './SingleLineData';

const CommunicationPanelCard = React.memo(
  ({ data, title, description = '', fileId = '', clientId }) => {
    const viewDocument = () => {
      axios
        .get(
          `${process.env.REACT_APP_BASE_URL}documents/${clientId}/files/${fileId}/content`,
        )
        .then(response => {
          const blob = creatBlobFromBase64(
            response.data.Content,
            response.data.ContentType,
          );
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, response.data.FileName);
          } else {
            const url = window.URL.createObjectURL(blob);
            if (response.data.ContentType === 'application/pdf') {
              window.open(url);
            } else {
              const a = window.document.createElement('a');
              window.document.body.appendChild(a);
              a.style = 'display: none';
              a.href = url;
              a.download = response.data.FileName;
              a.click();
              setTimeout(() => {
                window.document.body.removeChild(a);
              }, 0);
            }
          }
        });
    };

    return (
      <div className={style.main}>
        <div className={style.header}>
          <span className={style.title}>{title}</span>
          {fileId && (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events
            <a
              className={style.button}
              style={{ cursor: 'pointer' }}
              onClick={() => viewDocument()}
            >
              View
            </a>
          )}
        </div>
        {description && <div className={style.description}>{description}</div>}
        <div className={style.content}>
          {data.map((item, idx) => {
            return (
              <SingleLineData
                // eslint-disable-next-line react/no-array-index-key
                key={idx}
                label={item.label}
                value={item.value}
                type={item.type}
                contentStyle={{
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              />
            );
          })}
        </div>
      </div>
    );
  },
);

CommunicationPanelCard.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string,
    }).isRequired,
  ).isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  fileId: PropTypes.string,
  clientId: PropTypes.string.isRequired,
};

export default CommunicationPanelCard;
